import { render } from "./403.vue?vue&type=template&id=4dd39550&ts=true"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__